import { MIME_TYPES } from '@mantine/dropzone';
import {
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  MailruIcon,
  PinterestIcon,
  PinterestShareButton,
  RedditIcon,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
  TumblrIcon,
  TumblrShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon
} from 'react-share';

const PRODUCTION = true;
const TESTING = false;
const LOCAL_API = false;
const CONSOLE_DEBUG = false;

const COGNITO_SETTING_DEV = {
  Auth: {
    identityPoolId: 'us-east-1:5111a894-2c2c-41b1-a29a-f717eaa9aa31',
    region: 'us-east-1',
    userPoolId: 'us-east-1_Z2PFfqRF1',
    userPoolWebClientId: '624bs7emni9leiuspgcrrs9j8s',
    mandatorySignIn: true
  },
  Storage: {
    bucket: 'hockeyheadz-storage',
    region: 'us-east-1'
  }
};

const COGNITO_SETTING_PROD = {
  Auth: {
    identityPoolId: 'us-east-1:93ca516d-e2c4-4ad6-b44c-4b05604c8bd7',
    region: 'us-east-1',
    userPoolId: 'us-east-1_FAoqNjX2j',
    userPoolWebClientId: '4fdno1j1g5jukptomkdifu3gao',
    mandatorySignIn: true
  },
  Storage: {
    bucket: 'hockeyheadz-storage',
    region: 'us-east-1'
  }
};

const META_PIXEL_ID = '523029268675450';

const S3_PUBLIC_URL_OLD =
  'https://hockeyheadz-storage.s3.amazonaws.com/public/';
const S3_PUBLIC_URL = 'https://d2jdmybye7204a.cloudfront.net/public/';
const STORE_HOSTING_URL = 'https://store.sportsheadz.com';
const MAIN_HOSTING_URL = 'https://sportsheadz.com';

const PASSWORD_CONSTRAINTS = {
  length: 8,
  regexList: {
    capRegex: /\w*[A-Z]/,
    numRegex: /[0-9]/,
    symRegex: /[-!$%^&*()_+|~=`{}[\]:";'<>?,./]/
  }
};

const PAYMENT_PROVIDERS = {
  stripe: {
    value: 1,
    label: 'Stripe'
  }
};

const CURRENCY_TYPE_ENUM = {
  CAD: 1,
  USD: 2
};

const CURRENCY_TYPE_LIST = [
  {
    label: 'Canadian Dollar',
    fullLabel: 'Canadian Dollar (CAD $)',
    abbr: 'CAD',
    symbol: '$',
    value: CURRENCY_TYPE_ENUM.CAD
  },
  {
    label: 'US Dollar',
    fullLabel: 'US Dollar (USD $)',
    abbr: 'USD',
    symbol: '$',
    value: CURRENCY_TYPE_ENUM.USD,
    hidden: true
  }
];

const INPUT_CONTROL_TYPE_ENUM = {
  TEXT: 1,
  TEXT_INPUT: 2,
  DROP_DOWN: 3,
  DATE: 4,
  RADIO_GROUP: 5,
  CHECKBOX: 6,
  FILE_DOWNLOAD: 7,
  SIGNATURE: 8,
  FILE_UPLOAD: 9,
  SLIDER: 10,
  BUTTON_GROUP: 11,
  LINK: 12,
  COLOR: 13
};

const INPUT_CONTROL_TYPE_OPTIONS = [
  {
    label: 'Text input',
    value: INPUT_CONTROL_TYPE_ENUM.TEXT_INPUT
  },
  {
    label: 'Dropdown',
    value: INPUT_CONTROL_TYPE_ENUM.DROP_DOWN
  },
  {
    label: 'Date',
    value: INPUT_CONTROL_TYPE_ENUM.DATE
  },
  {
    label: 'Checkbox',
    value: INPUT_CONTROL_TYPE_ENUM.CHECKBOX
  },
  {
    label: 'File upload',
    value: INPUT_CONTROL_TYPE_ENUM.FILE_UPLOAD
  }
];

const BULK_EDIT_FIELD_TYPE_ENUM = {
  TEXT: 1,
  TEXT_PRICE: 2,
  SELECT: 3,
  SELECT_MULTIPLE: 4,
  NUMBER: 5,
  PRICE: 6,
  TEXT_INPUT: 7,
  DATE_TIME: 8,
  CHECKBOX: 9
};

const VIEW_ACTIONS_ENUM = {
  VIEW: 'VIEW',
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  DUPLICATE: 'DUPLICATE',
  DELETE: 'DELETE',
  RESTORE: 'RESTORE',
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
  CHANGE_STATUS: 'CHANGE_STATUS',
  ARCHIVE: 'ARCHIVE',
  UPLOAD: 'UPLOAD',
  ERROR: 'ERROR',
  DISCARD: 'DISCARD',
  REFUND: 'REFUND'
};

const ECOM_PRODUCT_PRICING_TYPE_ENUM = {
  STATIC: '1',
  PERCENTAGE_ADJUSTMENT: '2',
  FLAT_ADJUSTMENT: '3'
};

const ECOM_STORE_PRODUCT_PRICING_TYPE_LIST = [
  {
    value: ECOM_PRODUCT_PRICING_TYPE_ENUM.PERCENTAGE_ADJUSTMENT,
    label: 'Percentage Adjustment'
  },
  {
    value: ECOM_PRODUCT_PRICING_TYPE_ENUM.FLAT_ADJUSTMENT,
    label: 'Flat Adjustment'
  }
];

const ECOM_PRODUCT_STATUS_ENUM = {
  ACTIVE: '1',
  DRAFT: '2',
  ARCHIVED: '3',
  PENDING_ACTION: '4'
};

const ECOM_PRODUCT_STATUS_LIST = [
  {
    value: ECOM_PRODUCT_STATUS_ENUM.ACTIVE,
    label: 'Active'
  },
  {
    value: ECOM_PRODUCT_STATUS_ENUM.DRAFT,
    label: 'Draft'
  },
  {
    value: ECOM_PRODUCT_STATUS_ENUM.ARCHIVED,
    label: 'Archived'
  },
  {
    value: ECOM_PRODUCT_STATUS_ENUM.PENDING_ACTION,
    label: 'Pending Action'
  }
];

const ECOM_ORDER_STATUS_ENUM = {
  PROCESSING: '1',
  SUCCEEDED: '2',
  CANCELLED: '3',
  ACCUMULATING: '4',
  FULFILLED: '5',
  COMPLETED_OFFLINE: '6'
};

const ECOM_ORDER_PRODUCT_STATUS_ENUM = {
  PENDING: '1',
  CANCELLED: '2',
  REFUNDED: '3',
  SHIPPED: '4',
  DELIVERED: '5',
  ACCEPTED: '6',
  TRANSFERRED: '7'
};

const PAYMENT_PROVIDER_LINE_ITEM_TYPES = {
  registration: {
    value: 1,
    label: 'Registration'
  },
  merch: {
    value: 2,
    label: 'Merch'
  },
  invoice: {
    value: 3,
    label: 'Invoice'
  },
  ecommerce: {
    value: 4,
    label: 'Ecommerce'
  }
};

const WEIGHT_UNIT_ENUM = {
  G: '1',
  OZ: '2',
  KG: '3',
  LB: '4'
};

const WEIGHT_UNIT_LIST = [
  {
    value: WEIGHT_UNIT_ENUM.LB,
    label: 'lb'
  },
  {
    value: WEIGHT_UNIT_ENUM.OZ,
    label: 'oz'
  },
  {
    value: WEIGHT_UNIT_ENUM.KG,
    label: 'kg'
  },
  {
    value: WEIGHT_UNIT_ENUM.G,
    label: 'g'
  }
];

const SUPPORTED_MEDIA_TYPES = [
  MIME_TYPES.jpeg,
  MIME_TYPES.png,
  MIME_TYPES.svg,
  MIME_TYPES.webp,
  MIME_TYPES.heic
];

const ECOM_WEBSTORE_SECTION_BOUND_TYPE = {
  HEADER: 1,
  BODY: 2,
  FOOTER: 3
};

const ECOM_WEBSTORE_SECTION_TYPE_ENUM = {
  HEADER: 1,
  ANNOUNCEMENT_BAR: 2,
  FEATURED_COLLECTION: 3,
  FEATURED_PRODUCT: 4,
  COLLECTION_LIST: 5,
  RICH_TEXT: 6,
  IMAGE_WITH_TEXT: 7,
  IMAGE_BANNER: 8,
  SLIDESHOW: 9,
  COLLAGE: 10,
  MULTICOLUMN: 11,
  MULTIROW: 12,
  COLLAPSIBLE_CONTENT: 13,
  EMAIL_SIGNUP: 14,
  CONTACT_FORM: 15,
  VIDEO: 16,
  BLOG_POSTS: 17,
  PAGE: 18,
  FOOTER: 19,
  ACCOUNT_CONTENT: 20,
  PRODUCT_INFORMATION: 21,
  CHECKOUT_CONTENT: 22,
  PRODUCT_GRID: 23,
  RESOURCE_BANNER: 24,
  COLLECTION_GRID: 25,
  LAYERED_BANNER: 26,
  DESIGN_GRID: 27,
  DESIGN_LIST: 28,
  FEATURED_DESIGN: 29,
  CATEGORY_LIST: 30,
  CATEGORY_GRID: 31,
  BREADCRUMBS: 32
};

const ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM = {
  TEXT_LINK: 1,
  TEXT_OVER_IMAGE: 2,
  HEADING: 3,
  SUBHEADING: 4,
  TITLE: 5,
  TEXT: 6,
  CAPTION: 7,
  BUTTON_GROUP: 8,
  EMAIL_FORM: 9,
  PRICE: 10,
  VARIANT_PICKER: 11,
  QUANTITY_SELECTOR: 12,
  BUY_BUTTONS: 13,
  SKU: 14,
  RATING: 15,
  ICON_WITH_TEXT: 16,
  IMAGE: 17,
  COLLECTION: 18,
  PRODUCT: 19,
  VIDEO: 20,
  COLUMN_CONTENT: 21,
  ROW_CONTENT: 22,
  ACCORDION: 23,
  MENU: 24,
  BRAND_INFORMATION: 25,
  DESCRIPTION: 26,
  INVENTORY_STATUS: 27,
  CONTENT_CARD: 28,
  VENDOR_TITLE: 29,
  DESIGN: 30,
  CATEGORY: 31,
  SHARE_BUTTONS: 32
};

const ECOM_WEBSTORE_PAGE_TYPE_ENUM = {
  HOME: 1,
  PRODUCT: 2,
  COLLECTION: 3,
  COLLECTION_LIST: 4,
  CART: 5,
  CHECKOUT: 6,
  PAGE: 7,
  BLOG: 8,
  BLOG_POST: 9,
  SEARCH: 10,
  PASSWORD: 11,
  NOT_FOUND: 12,
  CUSTOMER_LOGIN: 13,
  CUSTOMER_REGISTER: 14,
  CUSTOMER_RESET_PASSWORD: 15,
  CUSTOMER_ACCOUNT: 16,
  CUSTOMER_ORDERS: 17,
  CUSTOMER_ORDER_DETAILS: 18,
  CUSTOMER_ADDRESSES: 19,
  DESIGN: 20,
  DESIGN_LIST: 21,
  EXPLORE: 22,
  CATEGORY: 23,
  CATEGORY_LIST: 24,
  ABOUT: 25
};

const ECOM_ENTITY_TYPES = {
  ecomStoreThemeColorScheme: 'ecomStoreThemeColorScheme',
  ecomStoreMedia: 'ecomStoreMedia',
  ecomStoreProduct: 'ecomStoreProduct',
  ecomStoreCollection: 'ecomStoreCollection',
  ecomStoreDesign: 'ecomStoreDesign',
  ecomStorePage: 'ecomStorePage',
  ecomStoreMenu: 'ecomStoreMenu',
  ecomCategory: 'ecomCategory'
};

const HEADING_SIZE_STYLE_ENUM = {
  EXTRA_SMALL: 'extra_small',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  EXTRA_LARGE: 'extra_large',
  HUGE: 'huge'
};

const PAYMENT_PROVIDER_LIST = [
  {
    label: 'Stripe',
    value: 1
  },
  {
    label: 'SportsPay',
    value: 2
  }
];

const CATALOG_SORT_OPTIONS = [
  {
    value: 'name',
    label: 'Relevance'
  },
  {
    value: 'top_selling_desc',
    label: 'Top Selling',
    path: 'top-sellers',
    pathTitle: 'Top Sellers'
  },
  {
    value: 'created_at_desc',
    label: 'Newest',
    path: 'new',
    pathTitle: 'Newest'
  },
  {
    value: 'price',
    label: 'Price'
  },
  {
    value: 'trending_desc',
    label: 'Popularity',
    path: 'trending',
    pathTitle: 'Trending'
  }
];

const PAYMENT_TYPE_ENUM = {
  CHEQUE: '1',
  CASH: '2',
  E_TRANSFER: '3',
  JUMPSTART: '4',
  REFUND: '5',
  INVOICE: '6',
  STRIPE: '7',
  AFTERPAY: '8',
  FORGIVENESS: '9',
  SPORTSPAY: '10',
  SPORTSPAY_INSTALLMENTS: '11',
  REIMBURSEMENT: '12',
  CREDIT: '13'
};

const PAYMENT_TYPE_LIST = [
  {
    label: 'Cheque',
    value: PAYMENT_TYPE_ENUM.CHEQUE
  },
  {
    label: 'Cash',
    value: PAYMENT_TYPE_ENUM.CASH
  },
  {
    label: 'E-Transfer',
    value: PAYMENT_TYPE_ENUM.E_TRANSFER
  },
  {
    label: 'Jumpstart',
    value: PAYMENT_TYPE_ENUM.JUMPSTART
  },
  {
    label: 'Refund',
    value: PAYMENT_TYPE_ENUM.REFUND
  },
  {
    label: 'Invoice',
    value: PAYMENT_TYPE_ENUM.INVOICE
  },
  {
    label: 'Stripe',
    value: PAYMENT_TYPE_ENUM.STRIPE
  },
  {
    label: 'Afterpay',
    value: PAYMENT_TYPE_ENUM.AFTERPAY
  },
  {
    label: 'Forgiveness',
    value: PAYMENT_TYPE_ENUM.FORGIVENESS
  },
  {
    label: 'SportsPay',
    value: PAYMENT_TYPE_ENUM.SPORTSPAY
  },
  {
    label: 'SportsPay Installments',
    value: PAYMENT_TYPE_ENUM.SPORTSPAY_INSTALLMENTS
  },
  {
    label: 'Reimbursement',
    value: PAYMENT_TYPE_ENUM.REIMBURSEMENT
  },
  {
    label: 'Credit',
    value: PAYMENT_TYPE_ENUM.CREDIT
  }
];

const ECOM_SHIPPING_CARRIER_ENUM = {
  CANADA_POST: 'Canada Post',
  UPS: 'UPS',
  FEDEX: 'FedEx',
  PUROLATOR: 'Purolator',
  DHL: 'DHL',
  USPS: 'USPS',
  OTHER: 'Other'
};

const ECOM_SHIPPING_CARRIER_LIST = [
  {
    label: 'Canada Post',
    value: ECOM_SHIPPING_CARRIER_ENUM.CANADA_POST
  },
  {
    label: 'UPS',
    value: ECOM_SHIPPING_CARRIER_ENUM.UPS
  },
  {
    label: 'FedEx',
    value: ECOM_SHIPPING_CARRIER_ENUM.FEDEX
  },
  {
    label: 'Purolator',
    value: ECOM_SHIPPING_CARRIER_ENUM.PUROLATOR
  },
  {
    label: 'DHL',
    value: ECOM_SHIPPING_CARRIER_ENUM.DHL
  },
  {
    label: 'USPS',
    value: ECOM_SHIPPING_CARRIER_ENUM.USPS
  },
  {
    label: 'Other',
    value: ECOM_SHIPPING_CARRIER_ENUM.OTHER
  }
];

const WEB_SAFE_FONT_OPTIONS = [
  { label: 'Arial', value: 'Arial, sans-serif' },
  { label: 'Bookman Old Style', value: 'Bookman Old Style, serif' },
  { label: 'Century Gothic', value: 'Century Gothic, sans-serif' },
  { label: 'Comic Sans MS', value: 'Comic Sans MS, cursive' },
  { label: 'Courier New', value: 'Courier New, monospace' },
  { label: 'Frank Ruhl Libre', value: 'Frank Ruhl Libre, serif' },
  { label: 'Georgia', value: 'Georgia, serif' },
  { label: 'Garamond', value: 'Garamond, serif' },
  { label: 'Helvetica', value: 'Helvetica, sans-serif' },
  { label: 'Impact', value: 'Impact, sans-serif' },
  { label: 'Lucida Console', value: 'Lucida Console, monospace' },
  { label: 'Lucida Sans Unicode', value: 'Lucida Sans Unicode, sans-serif' },
  { label: 'MS Sans Serif', value: 'MS Sans Serif, sans-serif' },
  { label: 'MS Serif', value: 'MS Serif, serif' },
  { label: 'Palatino Linotype', value: 'Palatino Linotype, serif' },
  { label: 'Segoe UI', value: 'Segoe UI, sans-serif' },
  { label: 'Tahoma', value: 'Tahoma, sans-serif' },
  { label: 'Times New Roman', value: 'Times New Roman, serif' },
  { label: 'Trebuchet MS', value: 'Trebuchet MS, sans-serif' },
  { label: 'Verdana', value: 'Verdana, sans-serif' }
];

const ECOM_EXTERNAL_CONNECTION_TYPE_ENUM = { PRINTIFY: '1', DUPLIUM: '2' };

const ECOM_IMAGE_POSITION_ENUM = { FRONT: '1', BACK: '2', SIDE: '3' };

const ECOM_IMAGE_POSITION_LIST = [
  {
    label: 'Front',
    value: ECOM_IMAGE_POSITION_ENUM.FRONT
  },
  {
    label: 'Back',
    value: ECOM_IMAGE_POSITION_ENUM.BACK
  },
  {
    label: 'Side',
    value: ECOM_IMAGE_POSITION_ENUM.SIDE
  }
];

const SOCIAL_SHARING_ENUM = {
  FACEBOOK: '1',
  X: '2',
  LINKEDIN: '3',
  PINTEREST: '4',
  EMAIL: '5',
  WHATSAPP: '6',
  REDDIT: '7',
  TUMBLR: '8',
  TELEGRAM: '9'
};

const SOCIAL_SHARING_LIST = [
  {
    value: SOCIAL_SHARING_ENUM.FACEBOOK,
    name: 'Facebook',
    Icon: FacebookIcon,
    ShareComponent: FacebookShareButton,
    webstoreConfigValue: 'facebookEnabled'
  },
  {
    value: SOCIAL_SHARING_ENUM.X,
    name: 'X',
    Icon: XIcon,
    ShareComponent: TwitterShareButton,
    webstoreConfigValue: 'xEnabled'
  },
  {
    value: SOCIAL_SHARING_ENUM.LINKEDIN,
    name: 'LinkedIn',
    Icon: LinkedinIcon,
    ShareComponent: LinkedinShareButton,
    webstoreConfigValue: 'linkedinEnabled'
  },
  {
    value: SOCIAL_SHARING_ENUM.PINTEREST,
    name: 'Pinterest',
    Icon: PinterestIcon,
    ShareComponent: PinterestShareButton,
    webstoreConfigValue: 'pinterestEnabled'
  },
  {
    value: SOCIAL_SHARING_ENUM.EMAIL,
    name: 'Email',
    Icon: MailruIcon,
    ShareComponent: EmailShareButton,
    webstoreConfigValue: 'emailEnabled'
  },
  {
    value: SOCIAL_SHARING_ENUM.WHATSAPP,
    name: 'WhatsApp',
    Icon: WhatsappIcon,
    ShareComponent: WhatsappShareButton,
    webstoreConfigValue: 'whatsappEnabled'
  },
  {
    value: SOCIAL_SHARING_ENUM.REDDIT,
    name: 'Reddit',
    Icon: RedditIcon,
    ShareComponent: RedditShareButton,
    webstoreConfigValue: 'redditEnabled'
  },
  {
    value: SOCIAL_SHARING_ENUM.TUMBLR,
    name: 'Tumblr',
    Icon: TumblrIcon,
    ShareComponent: TumblrShareButton,
    webstoreConfigValue: 'tumblrEnabled'
  },
  {
    value: SOCIAL_SHARING_ENUM.TELEGRAM,
    name: 'Telegram',
    Icon: TelegramIcon,
    ShareComponent: TelegramShareButton,
    webstoreConfigValue: 'telegramEnabled'
  }
];

const ECOM_STORE_STATUS_LIST = [
  {
    label: 'Live',
    value: 'live',
    color: 'green',
    isSelected: (s) => !s.isDemoStore && !s.sandboxEnabled
  },
  {
    label: 'Sandbox',
    value: 'sandbox',
    color: 'yellow',
    isSelected: (s) => !s.isDemoStore && s.sandboxEnabled
  },
  {
    label: 'Demo',
    value: 'demo',
    color: 'grey',
    isSelected: (s) => s.isDemoStore
  }
];

const SERVICE_TYPE_ENUM = {
  WEBSITE: '1',
  PLAYER_REG: '2',
  MOBILE_APP: '3',
  STORE: '4',
  SERVICE_API: '5',
  PAYMENT_API: '6',
  B2B_WEBSITE: '7'
};

const SERVICE_TYPE_LIST = [
  {
    label: 'Website',
    value: SERVICE_TYPE_ENUM.WEBSITE,
    canPublishCollections: false
  },
  {
    label: 'Player Registration',
    value: SERVICE_TYPE_ENUM.PLAYER_REG,
    canPublishCollections: true,
    singlePublish: true
  },
  {
    label: 'Mobile App',
    value: SERVICE_TYPE_ENUM.MOBILE_APP,
    canPublishCollections: false
  },
  {
    label: 'Online Store',
    value: SERVICE_TYPE_ENUM.STORE,
    canPublishCollections: true
  },
  {
    label: 'Service API',
    value: SERVICE_TYPE_ENUM.SERVICE_API,
    canPublishCollections: false
  },
  {
    label: 'Payment API',
    value: SERVICE_TYPE_ENUM.PAYMENT_API,
    canPublishCollections: false
  },
  {
    label: 'B2B Website',
    value: SERVICE_TYPE_ENUM.B2B_WEBSITE,
    canPublishCollections: false
  }
];

const ECOM_PRODUCT_BUNDLE_TYPE_ENUM = {
  FIXED_BUNDLE: '1',
  VOLUME_DISCOUNT: '2',
  MIX_AND_MATCH: '3',
  FREQUENTLY_BOUGHT_TOGETHER: '4',
  BUY_X_GET_Y: '5'
};

const ECOM_PRODUCT_BUNDLE_TYPE_LIST = [
  {
    label: 'Fixed Bundle',
    value: ECOM_PRODUCT_BUNDLE_TYPE_ENUM.FIXED_BUNDLE,
    description:
      'A predefined set of products sold together at a single fixed price. Customers can select available variations (e.g., size or color) for each item, but cannot add, remove, or change the products included in the bundle.'
  },
  {
    label: 'Mix and Match',
    value: ECOM_PRODUCT_BUNDLE_TYPE_ENUM.MIX_AND_MATCH,
    description:
      'A customizable bundle that allows customers to select specific products, variations, or quantities from a defined collection—often unlocking tiered or dynamic discounts based on their selections.'
  },
  {
    label: 'Buy X Get Y',
    value: ECOM_PRODUCT_BUNDLE_TYPE_ENUM.BUY_X_GET_Y,
    description:
      'A promotional offer where purchasing a specified quantity of product X qualifies the customer to receive product Y at a free or discounted price.'
  },
  {
    label: 'Volume Discount',
    value: ECOM_PRODUCT_BUNDLE_TYPE_ENUM.VOLUME_DISCOUNT,
    description:
      'A quantity-based pricing model where the unit price decreases as customers purchase higher quantities, incentivizing bulk purchases.'
  },
  {
    label: 'Frequently Bought Together',
    value: ECOM_PRODUCT_BUNDLE_TYPE_ENUM.FREQUENTLY_BOUGHT_TOGETHER,
    description:
      'A curated group of complementary products commonly purchased together, presented as a convenient set and typically offered with a bundled discount.'
  }
];

const ECOM_DISCOUNT_TYPE_ENUM = {
  SET_PRICE: '1',
  PERCENTAGE_DISCOUNT: '2',
  FLAT_DISCOUNT: '3',
  FREE_GIFT: '4',
  NO_DISCOUNT: '5'
};

const ECOM_DISCOUNT_TYPE_LIST = [
  {
    value: ECOM_DISCOUNT_TYPE_ENUM.NO_DISCOUNT,
    label: 'No discount'
  },
  {
    value: ECOM_DISCOUNT_TYPE_ENUM.PERCENTAGE_DISCOUNT,
    label: 'Percentage discount'
  },
  {
    value: ECOM_DISCOUNT_TYPE_ENUM.FLAT_DISCOUNT,
    label: 'Flat discount'
  },
  {
    value: ECOM_DISCOUNT_TYPE_ENUM.SET_PRICE,
    label: 'Set price'
  },
  {
    value: ECOM_DISCOUNT_TYPE_ENUM.FREE_GIFT,
    label: 'Free gift'
  }
];

const ECOM_PRINT_DESIGN_ITEM_TYPE_ENUM = {
  IMAGE: 1,
  TEXT: 2,
  PERSONALIZED_TEXT: 3
};

const ECOM_PRINT_DESIGN_ITEM_TYPE_LIST = [
  {
    value: ECOM_PRINT_DESIGN_ITEM_TYPE_ENUM.IMAGE,
    stringValue: 'image',
    label: 'Image'
  },
  {
    value: ECOM_PRINT_DESIGN_ITEM_TYPE_ENUM.TEXT,
    stringValue: 'text',
    label: 'Text'
  },
  {
    value: ECOM_PRINT_DESIGN_ITEM_TYPE_ENUM.PERSONALIZED_TEXT,
    stringValue: 'personalized_text',
    label: 'Personalized Text'
  }
];

export {
  PRODUCTION,
  TESTING,
  LOCAL_API,
  CONSOLE_DEBUG,
  COGNITO_SETTING_DEV,
  COGNITO_SETTING_PROD,
  META_PIXEL_ID,
  S3_PUBLIC_URL,
  S3_PUBLIC_URL_OLD,
  STORE_HOSTING_URL,
  MAIN_HOSTING_URL,
  PASSWORD_CONSTRAINTS,
  PAYMENT_PROVIDERS,
  CURRENCY_TYPE_ENUM,
  CURRENCY_TYPE_LIST,
  INPUT_CONTROL_TYPE_ENUM,
  INPUT_CONTROL_TYPE_OPTIONS,
  BULK_EDIT_FIELD_TYPE_ENUM,
  VIEW_ACTIONS_ENUM,
  ECOM_PRODUCT_PRICING_TYPE_ENUM,
  ECOM_STORE_PRODUCT_PRICING_TYPE_LIST,
  ECOM_PRODUCT_STATUS_ENUM,
  ECOM_PRODUCT_STATUS_LIST,
  ECOM_ORDER_STATUS_ENUM,
  ECOM_ORDER_PRODUCT_STATUS_ENUM,
  PAYMENT_PROVIDER_LINE_ITEM_TYPES,
  WEIGHT_UNIT_ENUM,
  WEIGHT_UNIT_LIST,
  SUPPORTED_MEDIA_TYPES,
  ECOM_WEBSTORE_SECTION_BOUND_TYPE,
  ECOM_WEBSTORE_SECTION_TYPE_ENUM,
  ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM,
  ECOM_ENTITY_TYPES,
  ECOM_WEBSTORE_PAGE_TYPE_ENUM,
  PAYMENT_PROVIDER_LIST,
  CATALOG_SORT_OPTIONS,
  PAYMENT_TYPE_ENUM,
  PAYMENT_TYPE_LIST,
  ECOM_SHIPPING_CARRIER_ENUM,
  ECOM_SHIPPING_CARRIER_LIST,
  WEB_SAFE_FONT_OPTIONS,
  ECOM_EXTERNAL_CONNECTION_TYPE_ENUM,
  ECOM_IMAGE_POSITION_ENUM,
  ECOM_IMAGE_POSITION_LIST,
  HEADING_SIZE_STYLE_ENUM,
  SOCIAL_SHARING_ENUM,
  SOCIAL_SHARING_LIST,
  ECOM_STORE_STATUS_LIST,
  SERVICE_TYPE_ENUM,
  SERVICE_TYPE_LIST,
  ECOM_PRODUCT_BUNDLE_TYPE_ENUM,
  ECOM_PRODUCT_BUNDLE_TYPE_LIST,
  ECOM_DISCOUNT_TYPE_ENUM,
  ECOM_DISCOUNT_TYPE_LIST,
  ECOM_PRINT_DESIGN_ITEM_TYPE_LIST,
  ECOM_PRINT_DESIGN_ITEM_TYPE_ENUM
};
